// hold component of Header: 1-Profile 2-logout 3- lang (dropDown) 4- Bill (Notification) 5- Toggle
import React, { Component } from 'react';
import './header.css'
import { Col, Row, ModalHeader, Button, Modal, ModalFooter, ModalBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import String from "../../../Assets/Localization/local.js";
import profile from '../../../Assets/Images/adminimage.png'
import { Link } from 'react-router-dom'
import { langauge, sendLogout } from '../../../Redux/Action/LoginAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { API_ENDPOINT } from '../../../AppConfig'
import axios from 'axios';
// import cookie from 'react-cookies'

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modallogout: false,
            dropdownProfile: false,
            dropdownNotification: false,
            smallScreen: false,
            User: [],
            prevLang: this.props.lang
        };
        this.modalLogout = this.modalLogout.bind(this);
        this.toggleProfile = this.toggleProfile.bind(this);
        this.toggleNotification = this.toggleNotification.bind(this);
    }
    modalLogout() {
        if (this.state.dropdownProfile) {
            this.setState(prevState => ({
                modallogout: !prevState.modallogout,
                dropdownProfile: false
            }));
        } else {
            this.setState(prevState => ({
                modallogout: !prevState.modallogout
            }));
        }

    }
    toggleProfile() {
        this.setState(prevState => ({
            dropdownProfile: !prevState.dropdownProfile
        }));
    }
    toggleNotification() {
        this.setState(prevState => ({
            dropdownNotification: !prevState.dropdownNotification
        }));
    }
    handlelang = () => {
        let direction = this.props.direction
        let token = this.props.token
        this.props.langauge(!direction ? "ar" : "en", token, { langauge: !direction ? "ar" : "en" })
        // this.setState({prevLang:!direction ? "ar" : "en"})
    }
    sendLogout = () => {
        
        this.props.sendLogout();
    }
    fetchprofile(id) {
        let uri = `${API_ENDPOINT}/userInfo?userId=${id}`
        axios.get(uri, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.props.lang,
                Authorization: `Bearer ${this.props.token}`
            }
        }).then(response => {
            this.setState({ User: response.data.user })
        }).catch(error => {
        })
    }
    UNSAFE_componentWillMount() {
        if (window.innerWidth < 766) {
            this.setState({ smallScreen: true })
        }
        this.fetchprofile(this.props.user.id)
        var moment = require('moment');
        if (this.props.lang === "ar") {
            require('moment/locale/ar');
            moment.locale("ar");
        }
        else {
            moment.locale("en");
        }
    }

    render() {
        const closedelete = <button className={this.props.lang === "ar" ? "close" : "closeEn"} onClick={this.modalLogout}>&times;</button>;
        String.setLanguage(this.props.lang);
        if (this.state.lang !== this.props.prevLang) {
            this.fetchprofile(this.props.user.id)
        }
        let direction = this.props.direction
        let user = this.props.user
        let open = this.props.IsOpen
        let path = this.props.path
// console.log("User Type:",user.type)
        return (
            <Row className={direction ? "header" : "headerEn"}>

                <Col lg="12" className={direction ? "uber-header text-left pt-2 pb-2 pl-3" : "uber-header text-right pt-2 pb-2 pr-3"}>
                    <div>
                        <i className="fa fa-power-off power" onClick={this.modalLogout}></i>
                        <span className="verticleLine"></span>
                        <span className="lang" onClick={this.handlelang}>
                            {direction ?
                                <span>  <i className="fa fa-globe-asia"></i>&nbsp;<span >EN</span> </span> :
                                <span> <span>AR</span>&nbsp;<i className="fa fa-globe-asia"></i> </span>
                            }
                        </span>
                        <span className="verticleLine"></span>
                        {/* Profile Dropdown */}
                        <Dropdown className="headerdropdown profiledropdown" isOpen={this.state.dropdownProfile} toggle={this.toggleProfile}>
                            <DropdownToggle>
                                <img src={user.image ? API_ENDPOINT + user.image : profile} className="avater" alt="profileimg" />
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem header className="text-center">
                                    <img src={user.image ? API_ENDPOINT + user.image : profile} className="avater m-0 mb-2" alt="profileimg" />
                                    <h5>{user.name}</h5>
                                    <h6>{user.email}</h6>
                                    <h6 style={{ direction: "rtl" }}> {String.memberSince} <span>
                                        <Moment format="D MMM YYYY" withTitle>
                                            {user.createdAt}
                                        </Moment>
                                    </span></h6>
                                    {/* <h6><Moment format="D MMM YYYY" withTitle>
                                    {user.createdAt}
                                </Moment></h6> */}
                                </DropdownItem>
                                <div className="d-flex py-2 px-2 footerprofiledrop" style={{ justifyContent: "space-between" }}>
                                    <Link to="/MyticketCinema/profile" onClick={this.toggleProfile}>
                                        {/* <i class="fas fa-user-circle drop-user"></i> */}
                                        <button>{String.profile}</button>
                                    </Link>
                                    <button onClick={this.modalLogout}>
                                        {/* <i className="fa fa-power-off power"></i> */}
                                        {String.SingOut}
                                    </button></div>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    {/* Notification Dropdown */}
                    {/* <span className="verticleLine"></span>
                       <Dropdown className="headerdropdown notifidropdown pl-2" isOpen={this.state.dropdownNotification} toggle={this.toggleNotification}>
                        <DropdownToggle>
                            <span>
                                <i className="fa  fa-bell bell">  <Badge color="secondary" className={direction ? "bellbadge-ar" : "bellbadge-en"}>1</Badge></i>
                            </span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem header className="text-center">You have 5 Notifications</DropdownItem>
                            <div className="notificationItem">
                                <p><span>Notification title</span> <i className="mr-3 fa fa-user"></i></p>
                            </div>
                            <div className="notificationItem">
                                <p><span>Notification title</span> <i className="mr-3 fa fa-user"></i></p>
                            </div>
                            <DropdownItem header className="text-center notificationFooter">
                                <Link to={{ pathname: '/MyticketCinema/profile' }}>View Notifications</Link>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown> */}

                    <Modal style={{ marginTop: "8%", zIndex: "1000000", borderRadius: "100px" }}
                        isOpen={this.state.modallogout} toggle={this.modalLogout} className="deleteReq">
                        <ModalHeader toggle={this.modalLogout} close={closedelete} className="text-center"><span className="logout-title">{String.logout}</span></ModalHeader>
                        <ModalBody style={{ fontWeight: "bold", color: "#636363" }}><h3>{String.confirmation}</h3></ModalBody>
                        <ModalFooter>
                            <div className=" btn LogoutBTN ">
                                <Button className="btn text-white" onClick={this.sendLogout}>{String.confirm}</Button>{' '}
                            </div>
                            <Button color="danger" onClick={this.modalLogout}>{String.CancelBTN}</Button>
                        </ModalFooter>
                    </Modal>
                </Col>
                <Col lg="12" className="px-0" style={{ borderTop: "1px solid #d8dbe0", boxShadow: "0 2px 2px 0 rgba(60,75,100,.14)" }}>
                    <div className="py-2 styleSubheader"
                        style={{ width: this.state.smallScreen ? "100vw" : open ? "83vw" : "95vw", textAlign: direction ? "right" : "left" }}>
                        {path.map((element, index) => {
                            return (
                                element.path !== "" ?
                                    <span key={index}>
                                        <Link to={`${element.path}`}>{element.key[this.props.lang]}</Link>
                                        {' '} {direction ? <span>\</span> : <span>/</span>} {' '}
                                    </span> :
                                    <span key={index}>
                                        {element.key[this.props.lang]}
                                    </span>
                            )
                        })}
                    </div>
                </Col>
            </Row>
        );
    }
}


const mapStateToProps = state => {
    return {
        token: state.userInfo.token,
        user: state.userInfo.user,
        lang: state.userInfo.language,
        path: state.subHeader.path,
       
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        langauge,
        sendLogout
    }
    , dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Header);
